module.exports = __webpack_public_path__ + "static/media/han-taste-banner1.7df6b169.png";